/* 🤖 this file was generated by svg-to-ts */
export const matIconBorderVertical: {
  name: 'border-vertical';
  data: string;
} = {
  name: 'border-vertical',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"/></svg>`
};
